module.exports = __webpack_public_path__ + "img/stage3.910db604.svg";